import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Home from "./components/Home";

import SubmitSuccess from "./pages/SubmitSucces";
import SubmitSuccessLink from "./pages/SubmitSuccessLink";
// acutal page imports for feedback app
import FeedbackForm3, { loader as feedbackForm3Loader } from "./FeedbackForm3";

// creating all locaSstorage empty variable

const router = createBrowserRouter(
  [
    { path: "/", element: <Home /> },
    {
      path: "feedback/:id",
      element: <FeedbackForm3 />,
      loader: feedbackForm3Loader,
    },
  
    {
      path: "submitsuccess",
      element: <SubmitSuccess />,
    },

    {
      path: "/externallink",
      element: <SubmitSuccessLink />,
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionStatusRevalidation: true,
    },
  }
);

function App() {
  return (
    <RouterProvider
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
      router={router}
    />
  );
}

export default App;
